import { render, staticRenderFns } from "./help_add.vue?vue&type=template&id=27f7d556&scoped=true"
import script from "./help_add.vue?vue&type=script&lang=js"
export * from "./help_add.vue?vue&type=script&lang=js"
import style0 from "./help_add.vue?vue&type=style&index=0&id=27f7d556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7d556",
  null
  
)

export default component.exports